<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      :width="width"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          :color="color"
          :icon="!!icon"
          :small="size === 'small'"
          :x-small="size === 'x-small'"
          :large="size === 'large'"
          :x-large="size === 'x-large'"
        >
          <v-icon v-if="!!icon" :color="color" :size="iconSize || size">{{ icon }}</v-icon>
          <template v-else>{{ button }}</template>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{ title }}
        </v-card-title>

        <v-card-text class="px-0 pb-0">
          <v-data-table
            :loading="useApi ? history.loading : false"
            :headers="headers"
            :items="displayItems"
            :items-per-page="-1"
            hide-default-footer
            fixed-header
            height="420px"
          >
            <template v-slot:item.from="{ item, header }">
              <slot name="from" v-bind:item="item.from">{{ item.from }}</slot>
            </template>
            <template v-slot:item.to="{ item, header }">
              <slot name="to" v-bind:item="item.to">{{ item.to }}</slot>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closureHandler"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      type: {},
      headers: {
        default: () => ([
          { text: 'Created', value: 'created', sortable: false },
          { text: 'Operator', value: 'operator', sortable: false },
          { text: 'From', value: 'from', sortable: false },
          { text: 'To', value: 'to', sortable: false },
        ])
      },
      icon: {},
      handler: {},
      size: {},
      iconSize: {},
      color: { default: 'grey' },
      width: { default: 500 },
      button: {},
      title: {},
      items: {
        type: Array,
        default: null
      },
      useApi: {
        type: Boolean,
        default: true
      }
    },

    data: () => ({
      dialog: false,
      history: {
        loading: false,
        items: []
      }
    }),
    computed: {
      ...mapGetters({ activeAccount: 'account/active' }),
      displayItems () {
        return (!this.useApi && this.items) ? this.items : this.history.items
      }
    },

    watch: {
      dialog (val) {
        this.history.items = []
        if (val && this.useApi) {
          this.loadData()
        }
      }
    },

    methods: {
      closureHandler: function () {
        this.dialog = false
      },
      loadData: function () {
        this.history.loading = true

        API.call(`/$v/account/update_history/${this.handler || this.type}.json`, {
          type: this.type,
          login: this.activeAccount.account.login,
          account_id: this.activeAccount.account.account_id,
        }, this.activeAccount.account).then(resp => {
          this.history.items = resp.data || []
          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.history.loading = false
        })

      }
    }

  }
</script>
